import script from "./ByPopularity.vue?vue&type=script&setup=true&lang=js"
export * from "./ByPopularity.vue?vue&type=script&setup=true&lang=js"

import "./ByPopularity.vue?vue&type=style&index=0&id=27d9fdf8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27d9fdf8"]])

export default __exports__